define(
    'modules/slideshow',[
        'jquery',
    ],

    function ($) {
        function Slideshow (slideshowContainer) {
            this.$slideshow = slideshowContainer;
            this.$itemscontainer = slideshowContainer.find(".slideshow__items-container");
        }

        Slideshow.prototype.intervalId = 0;
        Slideshow.prototype.autoplaySpeed = 0;
        Slideshow.prototype.autoplay = false;

        Slideshow.prototype.init = function() {
            var _this = this;

            if (this.$itemscontainer.find(".slideshow__item.active").length === 0) {
                _this.$itemscontainer.find(".slideshow__item").first().addClass("active");
            }

            this.setHeight();
            this.makeDots();
            this.setAutoplay();
            
            if (this.autoplay) {
                this.intervalId = setInterval(function () {
                    _this.nextSlide();
                }, this.autoplaySpeed);
            }
            
            this.$slideshow.on('mouseenter', function() { 
                if (_this.autoplay) {
                    clearInterval(_this.intervalId);
                }
            });

            this.$slideshow.on('mouseleave', function() { 
                if (_this.autoplay) {
                    _this.intervalId = setInterval(function() {
                        _this.nextSlide();
                    }, _this.autoplaySpeed);
                }
            });

            this.$slideshow.on('click', '.slideshow__next-btn', function(e){ e.preventDefault(); _this.nextSlide();});
            this.$slideshow.on('click', '.slideshow__prev-btn', function(e){ e.preventDefault(); _this.prevSlide();});
            this.$slideshow.on('click', '.dot', function(e){ _this.dotIndex(e); });
        };

        Slideshow.prototype.setAutoplay = function() {
            if (this.$slideshow.data('autoplayspeed')) {
                this.autoplaySpeed = this.$slideshow.data('autoplayspeed');
                this.autoplay = true;
            } else {
                clearInterval(this.intervalId);
                this.autoplay = false;
            }
        };

        Slideshow.prototype.setHeight = function() {
            var height = this.$slideshow.data("height");
            
            this.$slideshow.find(".slideshow__item").css({"height" : height});
            this.$itemscontainer.css({"height" : height});
        };

        Slideshow.prototype.nextSlide = function() {
            var activeItem = this.$itemscontainer.find(".slideshow__item.active"),
                activeItemIndex = activeItem.index(),
                slideshowItemTotal = this.$itemscontainer.find(".slideshow__item").length,
                nextItemIndex = 0;
    
            if (activeItemIndex + 1 > slideshowItemTotal - 1) {
                nextItemIndex = 0;
            } else {
                nextItemIndex = activeItemIndex + 1;
            }
            
            var nextItem = this.$itemscontainer.find(".slideshow__item").eq(nextItemIndex);
            var prevItem = this.$itemscontainer.find(".slideshow__item").eq(activeItemIndex);
            
            this.$itemscontainer.find(".slideshow__item").removeClass("inactive");
            activeItem.removeClass("active");
            nextItem.addClass("active");
            prevItem.addClass("inactive");
            this.$slideshow.find(".slideshow__dots").find(".dot").removeClass("active");
            this.$slideshow.find(".slideshow__dots").find(".dot").eq(nextItemIndex).addClass("active");
        };

        Slideshow.prototype.prevSlide = function() {
            var activeItem = this.$itemscontainer.find(".slideshow__item.active"),
                activeItemIndex = activeItem.index(),
                slideshowItemTotal = this.$itemscontainer.find(".slideshow__item").length,
                nextItemIndex = 0;
    
            if (activeItemIndex - 1 < 0) {
                nextItemIndex = slideshowItemTotal - 1;
            } else {
                nextItemIndex = activeItemIndex - 1;
            }
            
            var nextItem = this.$itemscontainer.find(".slideshow__item").eq(nextItemIndex);
            var prevItem = this.$itemscontainer.find(".slideshow__item").eq(activeItemIndex);
            
            this.$itemscontainer.find(".slideshow__item").removeClass("inactive");
            activeItem.removeClass("active");
            nextItem.addClass("active");
            prevItem.addClass("inactive");
            this.$slideshow.find(".slideshow__dots").find(".dot").removeClass("active");
            this.$slideshow.find(".slideshow__dots").find(".dot").eq(nextItemIndex).addClass("active");
        };

        Slideshow.prototype.makeDots = function() {
            var _this = this,
                activeItem = this.$itemscontainer.find(".slideshow__item.active"),
                activeItemIndex = activeItem.index(),
                slideshowItemTotal = this.$itemscontainer.find(".slideshow__item").length;
    
            for (i = 0; i < slideshowItemTotal; i++) {
                _this.$slideshow.find(".slideshow__dots").append("<div class='dot'></div>");
            }
            
            this.$slideshow.find(".slideshow__dots").find(".dot").eq(activeItemIndex).addClass("active");
        };
        
        Slideshow.prototype.dotIndex = function(e) {
            var dotIndex = $(e.currentTarget).index(),
                totalOffset = this.$itemscontainer.find(".slideshow__item").eq(dotIndex).offset().left - this.$itemscontainer.offset().left;
            
            this.$itemscontainer.find(".slideshow__item.active").removeClass("inactive");
            this.$itemscontainer.find(".slideshow__item.active").removeClass("active");
            this.$itemscontainer.find(".slideshow__item").eq(dotIndex).addClass("active");
            this.$slideshow.find(".slideshow__dots").find(".dot").removeClass("active");
            $(e.currentTarget).addClass("active");
        };

        return Slideshow;
    }
);
